// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import TinymceController from "./tinymce_controller"
application.register("tinymce", TinymceController)

import RegistrationFormController from "./registration_form_controller"
application.register("registration-form", RegistrationFormController)

import RegistrationSubmitController from "./registration/submit_controller"
application.register("registration--submit", RegistrationSubmitController)

import RegistrationPromoCodeController from "./registration/promo_code_controller"
application.register("registration--promo-code", RegistrationPromoCodeController)

import RegistrationPricingController from "./registration/pricing_controller"
application.register("registration--pricing", RegistrationPricingController)

import RegistrationAccommodationController from "./registration/accommodation_controller"
application.register("registration--accommodation", RegistrationAccommodationController)

import RegistrationSectionController from "./registration/section_controller"
application.register("registration--section", RegistrationSectionController)

import AdminInvoicePaymentController from "./admin/invoice_payment_controller"
application.register("admin--invoice-payment", AdminInvoicePaymentController)

import ToggleChecksController from "./toggle_checks_controller"
application.register("toggle-checks", ToggleChecksController)

import ToggleRequiredController from "./toggle_required_controller"
application.register("toggle-required", ToggleRequiredController)

import DisableForController from "./disable_for_controller"
application.register("disable-for", DisableForController)

import EvalToggleController from "./eval_toggle_controller"
application.register("eval-toggle", EvalToggleController)

import PostLinkController from "./post_link_controller"
application.register("post-link", PostLinkController)
